import { useState, useEffect, useRef, useCallback } from 'react'

const INACTIVITY_MS = 3 * 60 * 1000; // 3 minutos
const WARNING_S = 60; // 60s de contagem regressiva

function isNightMode(){
  const h = new Date().getHours();
  return h >= 18 || h < 7;
}

export function useInactivityGuard(user, onLogout){
  const [warning, setWarning]   = useState(false);
  const [countdown, setCountdown] = useState(WARNING_S);
  const [nightMode, setNightMode] = useState(isNightMode);

  const timerRef    = useRef(null);
  const countRef    = useRef(null);
  const warningRef  = useRef(false);
  const onLogoutRef = useRef(onLogout);
  onLogoutRef.current = onLogout; // atualiza a cada render sem useEffect

  const clearAll = useCallback(()=>{
    clearTimeout(timerRef.current);
    clearInterval(countRef.current);
  },[]);

  const startCountdown = useCallback(()=>{
    warningRef.current = true;
    setWarning(true);
    setCountdown(WARNING_S);
    let s = WARNING_S;
    countRef.current = setInterval(()=>{
      s -= 1;
      setCountdown(s);
      if(s <= 0){
        clearInterval(countRef.current);
        setWarning(false);
        warningRef.current = false;
        onLogoutRef.current();
      }
    }, 1000);
  },[]);

  const resetTimer = useCallback(()=>{
    if(!isNightMode()) return;
    if(warningRef.current) return; // não interrompe contagem regressiva
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(startCountdown, INACTIVITY_MS);
  },[startCountdown]);

  const dismiss = useCallback(()=>{
    // usuário clicou "Continuar" no modal
    clearAll();
    warningRef.current = false;
    setWarning(false);
    setCountdown(WARNING_S);
    resetTimer();
  },[clearAll, resetTimer]);

  // Atualizar nightMode a cada minuto
  useEffect(()=>{
    const id = setInterval(()=> setNightMode(isNightMode()), 60_000);
    return ()=> clearInterval(id);
  },[]);

  // Ativar/desativar guard conforme modo noturno e user logado
  useEffect(()=>{
    if(!user || !isNightMode()){
      clearAll();
      warningRef.current = false;
      setWarning(false);
      return;
    }
    const events = ['mousemove','keydown','mousedown','touchstart','scroll','click'];
    events.forEach(e => window.addEventListener(e, resetTimer, {passive:true}));
    resetTimer();
    return ()=>{
      clearAll();
      events.forEach(e => window.removeEventListener(e, resetTimer));
    };
  },[user, nightMode, resetTimer, clearAll]);

  return { warning, countdown, nightMode, dismiss };
}
